import { combineReducers } from 'redux';

import simpleSearchReducer from 'modules/global/reducers/simpleSearchReducer';
import { IMPORT_AUDITS_OR_TSCANS_SUCCESS } from 'modules/interventions/actionTypes';
import * as actionTypes from 'modules/tireQuote/actionTypes';

import data from 'modules/tireQuote/reducers/data';

import { createReducer } from 'utils/ReduxUtils';

export default combineReducers({
  data,
  search: simpleSearchReducer(actionTypes.SEARCH_TIRE_QUOTES_REQUEST, {
    global: {
      paginationSlice: true,
      matcher: ({ meta }) => meta.source === 'modal',
    },
    ids: {
      [actionTypes.OPEN_TIRE_QUOTES_IMPORT_MODAL]: () => [],
    },
  }),
  open: createReducer(false, {
    [actionTypes.OPEN_TIRE_QUOTES_IMPORT_MODAL]: () => true,
    [actionTypes.CLOSE_TIRE_QUOTES_IMPORT_MODAL]: () => false,
    [IMPORT_AUDITS_OR_TSCANS_SUCCESS]: () => false,
  })
});
